module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai220-faab0573963406abddfcb596287baaa2.jpg";